import { Modal } from 'octiv-components';
import { useActiveUserTenant } from 'octiv-context/ActiveUserTenant';
import { useSignedInUser } from 'octiv-context/SignedInUser';
import { useToggle } from 'octiv-hooks';
import { useLocationsUpdate } from 'octiv-hooks/requests/Locations';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Setting from '../../components/Setting';
import Form from './Form';
import Table from './Table';

export default () => {
  const { t } = useTranslation();
  const {
    tenant: { locations },
  } = useActiveUserTenant();
  const [toggle, setToggle, resetToggle] = useToggle();

  const { refetchSignedInUser } = useSignedInUser();

  const locationsUpdate = useLocationsUpdate({
    onSuccess: () => {
      resetToggle();
      refetchSignedInUser();
    },
    onError: () => {
      resetToggle();
    },
    meta: {
      useOnSuccessToast: true,
    },
  });

  const onClickAction = ({ action, locationId, hasRequestCancellation }) => {
    switch (action) {
      case 'edit':
        setToggle({
          type: 'edit',
          data: { locationId, hasRequestCancellation },
        });
        break;
      default:
        break;
    }
  };

  const onFormSubmit = async (values) => {
    locationsUpdate.mutate({
      id: toggle.data.locationId,
      hasRequestCancellation: values.autoCancel,
    });
  };

  return (
    <Setting title={t('locationSettings')}>
      {toggle.isVisible && (
        <Modal isSidebar title={t('locationSettings')} onClose={resetToggle}>
          <Form
            initialValues={toggle.data}
            isLoading={false}
            onSubmit={onFormSubmit}
          />
        </Modal>
      )}
      <Table
        hasAlternateBackground
        data={locations}
        onClickAction={onClickAction}
      />
    </Setting>
  );
};
